export default __webpack_public_path__ + "static/media/loadRing.5d80ee75.svg";